<template>
  <div class="camp-mine">
    <!-- 成长路径 -->
    <camp-level-progress class="mine-progress" :levels="levels" :member="member"></camp-level-progress>
    <div class="section-error" v-if="sectionErrors.profile">{{ sectionErrors.profile }}</div>
    <!-- 课程、考试、打卡 -->
    <div class="mine-tabs">
      <div
        class="tab-item"
        :class="{ cur: active === item.key }"
        v-for="item in tabs"
        :key="item.key"
        @click="changeTab(item.key)"
      >
        {{ item.label }}
        <img src="../../../assets/images/zone/img2.png" v-if="active === item.key" class="icon1" alt="">
      </div>
    </div>
    <div class="section-error" v-if="sectionErrors.tasks">{{ sectionErrors.tasks }}</div>
    <!-- 课程 -->
    <div class="mine-panel" v-if="active === 'course'">
      <div class="task-item" v-for="item in visibleCourses" :key="item.id" @click="goCourse(item)">
        <img class="task-cover" :src="item.coverUrl || cover" :title="item.title" alt="">
        <div class="task-main">
          <div class="task-title">
            {{ item.title }}
            <span class="task-badge" v-if="item.custom">定制</span>
          </div>
          <div class="task-desc">{{ item.hospital }}</div>
          <div class="task-line">
            <div class="task-desc">讲师：{{ item.teacher || '-' }}</div>
            <div class="task-side" :class="item.status">
              <i class="status-dot"></i>
              <span>{{ item.statusText }}</span>
              <i class="side-arrow"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-more course-more" v-if="courseList.length > 3" @click="courseFolded = !courseFolded">
        <span>{{ courseFolded ? '展开全部' : '收起' }}</span>
        <img class="more-icon" :class="{ up: !courseFolded }" src="@/assets/images/expand.svg" alt="">
      </div>
      <div class="task-empty" v-if="!tasksLoading && !sectionErrors.tasks && !courseList.length">暂无课程</div>
    </div>
    <!-- 考试 -->
    <div class="mine-panel" v-if="active === 'exam'">
      <div class="exam-item" v-for="item in visibleExams" :key="item.id" @click="goExam(item)">
        <div class="exam-mark" :class="{ muted: item.status === 'pending' }">
          <span>考试</span>
        </div>
        <div class="exam-main">
          <div class="exam-title">
            <span class="exam-title-text">{{ item.title }}</span>
            <span class="task-badge" v-if="item.custom">定制</span>
          </div>
          <div class="exam-meta">
            <span v-if="item.date">{{ item.date }}</span>
            <span class="exam-score" v-if="item.score">{{ item.score }}</span>
          </div>
        </div>
        <div class="exam-status" :class="item.status">
          <i class="status-dot"></i>
          <span>{{ item.statusText }}</span>
          <i class="side-arrow"></i>
        </div>
      </div>
      <div class="panel-more" v-if="examList.length > 3" @click="examFolded = !examFolded">
        <span>{{ examFolded ? '展开全部' : '收起' }}</span>
        <img class="more-icon" :class="{ up: !examFolded }" src="@/assets/images/expand.svg" alt="">
      </div>
      <div class="task-empty" v-if="!tasksLoading && !sectionErrors.tasks && !examList.length">暂无考试</div>
    </div>
    <!-- 打卡 -->
    <div class="mine-panel checkin-panel" v-if="active === 'checkin'">
      <template v-if="checkinSteps.length">
        <div class="checkin-head">
          <span>打卡进度</span>
          <span class="checkin-percent">{{ checkinPercent }}%</span>
        </div>
        <div class="checkin-bar"><i :style="{ width: checkinPercent + '%' }"></i></div>
        <div class="checkin-step" v-for="(item, index) in visibleSteps" :key="item.id" :class="item.state" @click="onStepClick(item)">
          <div class="step-rail">
            <i class="step-dot"></i>
            <i class="step-line" v-if="index < visibleSteps.length - 1"></i>
          </div>
          <div class="step-main" :style="{ opacity: item.state === 'locked' ? 0.5 : 1 }">
            <div class="step-no">技能节点{{ item.step }}</div>
            <div class="step-card">
              <div class="step-top">
                <div class="step-copy">
                  <div class="step-title">{{ item.title }}</div>
                  <div class="step-sub">{{ item.sub }}</div>
                </div>
                <div class="step-done" v-if="item.state === 'done'">
                  <div class="step-date">{{ item.date }}</div>
                  <div class="step-days">{{ item.days }}</div>
                </div>
                <button class="step-btn" type="button" v-else-if="item.state === 'open'" @click.stop="openCheckin(item)">打卡</button>
                <div class="step-lock" v-else>待解锁</div>
              </div>
              <div class="step-desc-row">
                <div class="step-desc">{{ item.desc }}</div>
                <img class="step-medal" v-if="item.state === 'done' && item.medalImage" :src="item.medalImage" :alt="item.medalName || '打卡勋章'">
              </div>
            </div>
          </div>
        </div>
        <div class="panel-more" v-if="checkinSteps.length > 3" @click="checkinFolded = !checkinFolded">
          <span>{{ checkinFolded ? '展开全部' : '收起' }}</span>
          <img class="more-icon" :class="{ up: !checkinFolded }" src="@/assets/images/expand.svg" alt="">
        </div>
      </template>
      <div class="task-empty" v-else-if="!tasksLoading && !sectionErrors.tasks">暂无打卡</div>
    </div>
    <!-- 消息 -->
    <div class="mine-block" v-if="messages.length || sectionErrors.messages">
      <div class="block-title">消息</div>
      <div class="section-error" v-if="sectionErrors.messages">{{ sectionErrors.messages }}</div>
      <div
        class="message-item"
        :class="{ unread: item.unread }"
        v-for="item in messages"
        :key="item.id"
        @click="openMessage(item)"
      >
        <div class="message-icon">
          <img src="@/assets/images/researchCamp/me_message.svg" alt="">
          <i class="message-dot" v-if="item.unread"></i>
        </div>
        <div class="message-main">
          <div class="message-text">{{ item.content || item.name }}</div>
          <div class="message-foot">
            <span>{{ item.time }}</span>
            <span class="message-link">查看详情<i class="link-arrow"></i></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 任务完成率 -->
    <div class="mine-block is-rate">
      <div class="block-title">任务完成率</div>
      <div class="section-error" v-if="sectionErrors.rates">{{ sectionErrors.rates }}</div>
      <div class="rate-row">
        <div class="rate-item" v-for="item in rates" :key="item.label">
          <div class="rate-label">{{ item.label }}</div>
          <div class="rate-value">{{ item.done }}<span>/{{ item.total }}</span></div>
        </div>
      </div>
      <div class="rate-row rate-row-sub">
        <div class="rate-item rate-item-sub" v-for="item in practiceRates" :key="item.label" @click="openPractice(item)">
          <div class="rate-label">{{ item.label }}</div>
          <div class="rate-value">{{ item.done }}<span>{{ item.unit }}</span><i class="value-arrow" v-if="item.arrow"></i></div>
        </div>
      </div>
    </div>
    <!-- 未读消息详情 -->
    <van-popup v-model="messageVisible" class="message-popup" get-container="body" :close-on-click-overlay="false">
      <template v-if="currentMessage">
        <div class="popup-name">消息详情</div>
        <div class="popup-content">{{ currentMessage.content }}</div>
        <button class="popup-close" type="button" @click="messageVisible = false">关闭</button>
      </template>
    </van-popup>
    <!-- 所属中心 -->
    <camp-center-entry :camp="center" @open="goDetail"></camp-center-entry>
    <!-- 虚拟模拟器考核 -->
    <camp-vsim-popup v-model="vsimVisible" :items="vsimProgress" :loading="ratesLoading"></camp-vsim-popup>
    <!-- 打卡 -->
    <camp-checkin ref="checkin" @done="onCheckinDone"></camp-checkin>
  </div>
</template>

<script>
import CampCheckin from './CampCheckin.vue'
import CampLevelProgress from './CampLevelProgress.vue'
import CampVsimPopup from './CampVsimPopup.vue'
import CampCenterEntry from './CampCenterEntry.vue'
import { formatCampDate, formatCampDateTime } from '../date'
import {
  getResearchCampMemberProfile,
  getResearchCampLearningTasks,
  getResearchCampHomeMessages,
  getResearchCampCompletionRates,
  markResearchCampMessageRead
} from '@/api/researchCamp'

export default {
  name: 'CampStudentHome',
  props: {
    campConfigId: {
      type: [Number, String],
      default: null
    },
    viewRole: {
      type: String,
      default: 'LEARNER'
    }
  },
  components: {
    CampCheckin,
    CampLevelProgress,
    CampVsimPopup,
    CampCenterEntry
  },
  data () {
    return {
      // 列表封面沿用前端固定资源，业务资料和各内容分区均读取研修营接口。
      cover: require('@/assets/images/researchCamp/banner.png'),
      active: 'course',
      courseFolded: true,
      examFolded: true,
      examOpening: false,
      checkinFolded: true,
      messageVisible: false,
      vsimVisible: false,
      vsimProgress: [],
      ratesLoading: false,
      currentMessage: null,
      campMemberId: null,
      memberEntryDate: null,
      sectionErrors: {
        profile: '',
        tasks: '',
        messages: '',
        rates: ''
      },
      tasksLoading: false,
      member: {},
      levels: [],
      tabs: [
        { key: 'course', label: '课程' },
        { key: 'exam', label: '考试' },
        { key: 'checkin', label: '打卡' }
      ],
      courseList: [],
      examList: [],
      checkinSteps: [],
      messages: [],
      rates: [],
      practiceRates: [],
      center: {}
    }
  },
  created () {
    this.loadHomeSections()
  },
  computed: {
    // 打卡完成百分比
    checkinPercent () {
      const total = this.checkinSteps.length
      const done = this.checkinSteps.filter(item => item.state === 'done').length
      return total ? Math.round(done / total * 100) : 0
    },
    // 打卡列表。收起时只显示前三条
    visibleSteps () {
      return this.checkinFolded ? this.checkinSteps.slice(0, 3) : this.checkinSteps
    },
    // 课程列表。收起时只显示前三条
    visibleCourses () {
      return this.courseFolded ? this.courseList.slice(0, 3) : this.courseList
    },
    // 考试列表。收起时只显示前三条
    visibleExams () {
      return this.examFolded ? this.examList.slice(0, 3) : this.examList
    }
  },
  methods: {
    // 加载资料、任务、消息和完成率
    loadHomeSections () {
      this.loadProfile()
      this.loadLearningTasks()
      this.loadMessages()
      this.loadCompletionRates()
    },
    // 新接口优先按三态展示，兼容尚未返回 status 的旧接口。
    taskState (item, doneText) {
      const status = item && item.status ? item.status : (item && item.done ? 'DONE' : 'TODO')
      if (status === 'DONE') return { tone: 'done', text: doneText }
      if (status === 'IN_PROGRESS') return { tone: 'doing', text: '进行中' }
      return { tone: 'pending', text: '未开始' }
    },
    // 加载学员资料和成长路径
    async loadProfile () {
      this.sectionErrors.profile = ''
      try {
        const response = await getResearchCampMemberProfile(this.campConfigId, { viewRole: this.viewRole })
        const data = response && response.data ? response.data : {}
        const member = data.member || {}
        const iepProfile = data.iepProfile || {}
        const camp = data.camp || {}
        this.campMemberId = member.campMemberId || null
        this.memberEntryDate = this.toLocalDate(member.entryTime)
        this.$emit('profile-change', {
          name: iepProfile.name || member.name || '',
          meta: [iepProfile.hospitalName, iepProfile.departmentL1, iepProfile.positionTitle].filter(Boolean).join(' '),
          joinDate: this.formatDate(member.entryTime)
        })
        this.center = camp
        this.member = member
        this.levels = data.levels || []
      } catch (error) {
        this.sectionErrors.profile = error && error.msg ? error.msg : '个人资料加载失败'
      }
    },
    // 加载课程、考试和打卡
    async loadLearningTasks () {
      this.tasksLoading = true
      this.sectionErrors.tasks = ''
      try {
        const response = await getResearchCampLearningTasks(this.campConfigId, { viewRole: this.viewRole })
        const data = response && response.data ? response.data : {}
        this.courseList = (data.courses || []).map(item => {
          const state = this.taskState(item, '已完成')
          return {
            id: item.courseId || item.resourceId || item.id,
            planItemId: item.planItemId,
            dispatchMemberId: item.dispatchMemberId,
            title: item.name || '',
            hospital: item.courseHospitalName || '',
            teacher: item.courseLecturerNames || '',
            coverUrl: item.coverUrl || '',
            status: state.tone,
            statusText: state.text,
            custom: item.source === 'CUSTOM'
          }
        })
        this.examList = (data.exams || []).map(item => {
          const state = this.taskState(item, '已完成')
          return {
            id: item.examId || item.resourceId || item.id,
            planItemId: item.planItemId,
            dispatchMemberId: item.dispatchMemberId,
            title: item.name || '',
            date: this.formatDate(item.latestSubmittedAt),
            score: item.latestScore === null || item.latestScore === undefined ? '' : `${item.latestScore}分`,
            status: state.tone,
            statusText: state.text,
            custom: item.source === 'CUSTOM'
          }
        })
        this.checkinSteps = (data.checkins || []).map((item, index) => ({
          id: item.planItemId,
          step: index + 1,
          state: item.completed ? 'done' : item.unlocked ? 'open' : 'locked',
          minCheckinDate: item.minCheckinDate,
          title: item.taskType,
          sub: item.name,
          desc: item.description,
          date: this.formatDate(item.checkinDate),
          days: item.intervalDays === null || item.intervalDays === undefined ? '' : `${item.intervalDays}天`,
          medalName: item.medalName,
          medalImage: item.medalImage
        }))
      } catch (error) {
        this.sectionErrors.tasks = error && error.msg ? error.msg : '学习任务加载失败'
      } finally {
        this.tasksLoading = false
      }
    },
    // 加载学员消息
    async loadMessages () {
      this.sectionErrors.messages = ''
      try {
        const response = await getResearchCampHomeMessages(this.campConfigId, { viewRole: this.viewRole })
        const rows = response && Array.isArray(response.data) ? response.data : []
        this.messages = rows.map(item => ({
          id: item.dispatchMemberId,
          dispatchMemberId: item.dispatchMemberId,
          unread: !item.read,
          name: item.title || '',
          content: item.content || '',
          time: formatCampDateTime(item.createdAt)
        }))
      } catch (error) {
        this.sectionErrors.messages = error && error.msg ? error.msg : '消息加载失败'
      }
    },
    // 加载任务完成率
    async loadCompletionRates () {
      this.sectionErrors.rates = ''
      this.ratesLoading = true
      try {
        const response = await getResearchCampCompletionRates(this.campConfigId, { viewRole: this.viewRole })
        const stats = response && response.data ? response.data : []
        const virtualSimulator = stats.find(item => item.key === 'virtualSimulator')
        this.vsimProgress = virtualSimulator && Array.isArray(virtualSimulator.details)
          ? virtualSimulator.details
          : []
        this.rates = stats.filter(item => ['course', 'customCourse', 'exam', 'customExam', 'checkin'].includes(item.key))
          .map(item => ({ label: item.label, done: item.done, total: item.total === null ? '-' : item.total }))
        this.practiceRates = stats.filter(item => ['virtualSimulator', 'physicalSimulator', 'caseReview', 'handsOnPractice'].includes(item.key))
          .map(item => ({
            label: item.label,
            done: item.done,
            unit: item.total === null ? (item.unit || '') : `/${item.total}`,
            arrow: item.key === 'virtualSimulator',
            key: item.key === 'virtualSimulator' ? 'vsim' : item.key
          }))
      } catch (error) {
        this.vsimProgress = []
        this.sectionErrors.rates = error && error.msg ? error.msg : '任务完成率加载失败'
      } finally {
        this.ratesLoading = false
      }
    },
    // 入营时间转成本地日期，供打卡间隔使用
    toLocalDate (value) {
      if (!value) return null
      if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate())
      const raw = String(value)
      if (/^\d+$/.test(raw)) {
        const date = new Date(Number(raw))
        return new Date(date.getFullYear(), date.getMonth(), date.getDate())
      }
      const parts = raw.slice(0, 10).split('-').map(Number)
      return parts.length === 3 && parts.every(Number.isFinite)
        ? new Date(parts[0], parts[1] - 1, parts[2])
        : null
    },
    // 切换课程、考试、打卡
    changeTab (key) {
      this.active = key
    },
    // 进入中心详情，不用 campId，避免被旧训练营路由守卫拦截
    goDetail () {
      this.$router.push({ path: '/researchCamp/detail', query: { researchCampId: this.campConfigId } })
    },
    // 虚拟模拟器打开考核弹窗
    openPractice (item) {
      if (item.key === 'vsim') this.vsimVisible = true
    },
    // 固定考试按计划顺序进行，已提交的考试（无论是否通过）视为完成。
    hasUnfinishedPreviousExam (item) {
      if (!item || item.custom || item.status === 'done') return false
      const index = this.examList.findIndex(exam => String(exam.planItemId) === String(item.planItemId))
      if (index <= 0) return false
      return this.examList.slice(0, index).some(exam => !exam.custom && exam.status !== 'done')
    },
    // 进入研修营答题页，不走班级考试路由
    goExam (item) {
      if (this.hasUnfinishedPreviousExam(item)) {
        this.$toast('请先完成前序考试')
        return
      }
      this.$router.push({
        path: '/researchCamp/exam',
        query: {
          researchCampId: this.campConfigId,
          planItemId: item.planItemId || '',
          dispatchMemberId: item.dispatchMemberId || ''
        }
      })
    },
    // 跳转课程，入口 181
    goCourse (item) {
      const entrance = 181
      window.sessionStorage.setItem('entrance', entrance)
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/courserDetails?courseId=${item.id}&entrance=${entrance}&channel=${entrance}`)
      this.$router.push({
        path: '/courserDetails',
        query: {
          courseId: item.id,
          entrance,
          channel: entrance
        }
      })
    },
    // 打开打卡。没有入营日期时不能打卡
    openCheckin (item) {
      if (!this.memberEntryDate) {
        this.$toast('入营日期缺失，暂不能打卡')
        return
      }
      this.$refs.checkin.openTask(item, this.memberEntryDate)
    },
    // 已打卡提示已打卡，未解锁提示先完成上一节点
    onStepClick (item) {
      if (item.state === 'done') {
        this.$toast('已打卡')
        return
      }
      if (item.state === 'locked') {
        const index = this.checkinSteps.findIndex(step => step.id === item.id)
        const prev = this.checkinSteps[index - 1]
        this.$toast(prev ? `请先完成「${prev.sub}」` : '该节点尚未解锁')
        return
      }
      this.openCheckin(item)
    },
    // 打开消息详情
    openMessage (item) {
      if (item.unread) {
        markResearchCampMessageRead(item.dispatchMemberId).then(() => {
          item.unread = false
        }).catch(error => {
          this.$toast(error && error.msg ? error.msg : '消息已读状态更新失败')
        })
      }
      this.currentMessage = item
      this.messageVisible = true
    },
    // 打卡成功后重新读取服务端状态和自然日间隔。
    onCheckinDone () {
      this.loadLearningTasks()
      this.loadCompletionRates()
    },
    // 日期格式化
    formatDate (value) {
      return formatCampDate(value)
    },
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.camp-mine {
  padding-bottom: 24px;

  .section-error {
    padding: 8px @camp-side;
    font-size: 12px;
    color: @camp-red;
  }

  .mine-progress {
    margin-top: 16px;
  }

  .mine-tabs {
    display: flex;
    height: 48px;
    margin: 12px @camp-side 0;

    .tab-item {
      flex: 1;
      position: relative;
      line-height: 48px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: @camp-muted;

      &.cur {
        color: @camp-red;
        font-weight: 500;
      }

      .icon1 {
        position: absolute;
        left: 50%;
        bottom: 6px;
        width: 24px;
        transform: translateX(-50%);
      }
    }
  }

  .mine-panel,
  .mine-block {
    .camp-white-card();
  }

  .mine-panel {
    padding: 4px 14px 12px;

    .task-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;

      .task-cover {
        width: 100px;
        height: 58px;
        margin-right: 10px;
        border-radius: 5px;
        object-fit: cover;
        flex-shrink: 0;
      }

      .task-main {
        flex: 1;
        min-width: 0;
      }

      .task-title {
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        color: @camp-text;
      }

      .task-line {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .task-desc {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .task-desc {
        font-size: 11px;
        line-height: 20px;
        color: @camp-sub;
      }

      .task-side {
        display: flex;
        align-items: center;
        margin-left: 8px;
        font-size: 11px;
        font-weight: 400;
        line-height: 20px;
        flex-shrink: 0;

        &.doing {
          color: #00a2ff;
        }

        &.done {
          color: #38C976;
        }

        &.pending {
          color: #999;
        }
      }

      .status-dot {
        width: 4px;
        height: 4px;
        margin-right: 4px;
        border-radius: 50%;
        background: currentColor;
      }

      .side-arrow {
        width: 4px;
        height: 4px;
        margin-left: 3px;
        border-top: 1px solid #d5cfc9;
        border-right: 1px solid #d5cfc9;
        transform: rotate(45deg);
      }
    }

    .panel-more {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 12px;
      text-align: center;
      font-size: 12px;
      line-height: 18px;
      color: @camp-sub;

      .more-icon {
        width: 9px;
        height: 5px;
        margin-left: 4px;
        filter: brightness(0) saturate(100%);
        opacity: 0.55;

        &.up {
          transform: rotate(180deg);
        }
      }
    }

    .exam-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;
    }

    .exam-mark {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border-radius: 8px;
      background: #ff8d28;
      flex-shrink: 0;

      &.muted {
        background: #a39992;
      }

      span {
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        color: #fff;
      }
    }

    .exam-main {
      flex: 1;
      min-width: 0;
    }

    .exam-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .exam-title {
      display: flex;
      align-items: flex-start;
      flex: 1;
      min-width: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: @camp-text;
    }

    .exam-title-text {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      min-width: 0;
    }

    .exam-title .task-badge {
      flex-shrink: 0;
      margin-top: 2px;
    }

    .task-badge {
      display: inline-block;
      margin-left: 4px;
      padding: 0 6px;
      height: 16px;
      border-radius: 8px;
      font-size: 11px;
      font-weight: 400;
      line-height: 16px;
      color: @camp-red;
      background: rgba(235, 23, 0, 0.08);
      vertical-align: 1px;
    }

    .exam-meta {
      font-size: 12px;
      font-weight: 300;
      line-height: 20px;
      color: #a39992;
    }

    .exam-score {
      margin-left: 6px;
      font-size: 10px;
      font-weight: 400;
      color: #ffa800;
    }

    .exam-status {
      display: flex;
      align-items: center;
      margin-left: 8px;
      font-size: 11px;
      font-weight: 400;
      line-height: 20px;
      flex-shrink: 0;

      &.doing {
        color: #00a2ff;
      }

      &.done {
        color: #38C976;
      }

      &.pending {
        color: #999;
      }

      .status-dot {
        width: 4px;
        height: 4px;
        margin-right: 4px;
        border-radius: 50%;
        background: currentColor;
      }

      .side-arrow {
        width: 4px;
        height: 4px;
        margin-left: 3px;
        border-top: 1px solid #d5cfc9;
        border-right: 1px solid #d5cfc9;
        transform: rotate(45deg);
      }
    }

    .checkin-head {
      display: flex;
      justify-content: space-between;
      padding-top: 12px;
      font-size: 12px;
      line-height: 24px;
      color: @camp-text;
    }

    .checkin-percent {
      font-weight: 500;
      color: @camp-red;
    }

    .checkin-bar {
      height: 6px;
      margin: 4px 0 8px;
      border-radius: 12px;
      background: #e6e6e6;
      overflow: hidden;

      i {
        display: block;
        height: 6px;
        border-radius: 12px;
        background: linear-gradient(90deg, #ff5b0c 0%, #eb1700 100%);
      }
    }

    .task-empty {
      padding: 16px 0;
      text-align: center;
      font-size: 12px;
      color: @camp-sub;
    }

    .checkin-step {
      display: flex;
      align-items: stretch;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      .step-rail {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 13px;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .step-dot {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 13px;
        height: 13px;
        margin-top: 3px;
        border-radius: 50%;
        background: #e7e7e7;
        flex-shrink: 0;

        &:after {
          content: '';
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #000;
        }
      }

      .step-line {
        flex: 1;
        width: 0;
        margin-top: 2px;
        margin-bottom: -6px;
        border-left: 1px dashed #979797;
      }

      &.done .step-dot {
        background: rgba(255, 91, 12, 0.1);

        &:after {
          background: @camp-red;
        }
      }

      &.done .step-line {
        border-left-color: @camp-red;
      }

      &.locked .step-dot:after {
        background: rgba(0, 0, 0, 0.4);
      }

      .step-main {
        flex: 1;
        min-width: 0;
      }

      .step-no {
        font-size: 14px;
        line-height: 20px;
        color: @camp-text;
      }

      .step-card {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 4px;
        background: #f9f8f7;
        box-sizing: border-box;
      }

      .step-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      .step-copy {
        flex: 1;
        min-width: 0;
        margin-right: 8px;
      }

      .step-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        color: @camp-text;
      }

      &.locked .step-no {
        color: #81766f;
      }

      .step-done {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex-shrink: 0;
      }

      .step-date {
        font-size: 12px;
        line-height: 20px;
        color: #53ce76;
      }

      .step-days {
        margin-top: 2px;
        padding: 0 6px;
        height: 16px;
        line-height: 16px;
        border-radius: 8px;
        font-size: 10px;
        color: #53ce76;
        background: #e1f2e4;
      }

      .step-btn {
        height: 22px;
        line-height: 22px;
        padding: 0 14px;
        border: 0;
        border-radius: 11px;
        font-size: 11px;
        color: #fff;
        background: @camp-red;
        flex-shrink: 0;
      }

      .step-lock {
        padding: 0 8px;
        height: 20px;
        line-height: 20px;
        border-radius: 10px;
        font-size: 11px;
        color: #303133;
        background: #ababab;
        flex-shrink: 0;
      }

      .step-sub {
        font-size: 12px;
        line-height: 24px;
        color: @camp-text;
      }

      .step-desc-row {
        display: flex;
        align-items: center;
      }

      .step-desc {
        flex: 1;
        min-width: 0;
        font-size: 12px;
        line-height: 20px;
        color: @camp-sub;
      }

      .step-medal {
        width: 21px;
        height: 18px;
        margin-left: 8px;
        flex-shrink: 0;
        object-fit: cover;
      }
    }
  }

  .mine-block {
    margin-top: 13px;
    padding: 16px 10px 10px 10px;

    .block-title {
      margin-bottom: 14px;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      color: @camp-text;
    }
  }

    .message-item {
    display: flex;
    padding-top: 12px;

    &.unread {
      cursor: pointer;
    }

    & + .message-item {
      margin-top: 12px;
      border-top: 1px solid @camp-line;
    }

    .message-icon {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      flex-shrink: 0;

      img {
        width: 42px;
        height: 42px;
        display: block;
      }

      .message-dot {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @camp-red;
      }
    }

    .message-main {
      flex: 1;
      min-width: 0;
    }

    .message-text {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      word-break: break-word;
      color: @camp-text;
    }

    .message-foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 4px;
      font-size: 12px;
      line-height: 20px;
      color: #a39992;
    }

    .message-link {
      display: flex;
      align-items: center;
    }

    .link-arrow {
      width: 4px;
      height: 4px;
      margin-left: 4px;
      border-top: 1px solid #a39992;
      border-right: 1px solid #a39992;
      transform: rotate(45deg);
    }
  }

  .mine-block.is-rate {
    background: #eb1700 url('../../../assets/images/researchCamp/ph_bg.png') no-repeat center / cover;

    .block-title {
      color: #fff;
    }

    .section-error {
      padding: 0 0 8px;
      color: #fff;
    }
  }

  .rate-row {
    display: flex;
    gap: 8px;

    .rate-item {
      flex: 1;
      min-width: 0;
      padding: 8px 0;
      border-radius: 6px;
      text-align: center;
      background: #fff;
    }

    .rate-label {
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      color: #564C47;
    }

    .rate-value {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #000;

      span {
        font-size: 10px;
        font-weight: 400;
      }
    }

    .value-arrow {
      display: inline-block;
      width: 4px;
      height: 4px;
      margin-left: 2px;
      border-top: 1px solid #564C47;
      border-right: 1px solid #564C47;
      transform: rotate(45deg);
      vertical-align: 1px;
    }
  }

  .rate-row-sub {
    margin-top: 10px;
  }

}

.message-popup {
  width: 300px;
  padding: 20px 16px 16px;
  border-radius: 10px;
  box-sizing: border-box;

  .popup-name {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    color: #000;
  }

  .popup-content {
    height: 220px;
    margin-top: 12px;
    margin-bottom: 16px;
    overflow-y: auto;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #000;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .popup-close {
    display: block;
    width: 100%;
    height: 40px;
    border: 0;
    border-radius: 20px;
    color: #fff;
    background: #eb1700;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampStudentHome.vue